import Vue from 'vue';
Vue.config.devtools = true;
import IndividualAccounts from './components/IndividualAccounts.vue';

var individualAccountsEl = document.getElementById('individual-accounts');

if (typeof (individualAccountsEl) != 'undefined' && individualAccountsEl != null) {
    var individualAccounts = new Vue({
        el: '#individual-accounts',
        components: {
            "individual-accounts": IndividualAccounts
        }
    });
}


// WEBPACK FOOTER //
// ./Scripts/app/fl/index.js